export type UserGender = 'male' | 'female';

export const USER_GENDER_LABELS: Record<UserGender, string> = {
  male: 'Homem',
  female: 'Mulher',
};

export const DEFAULT_USER_AVATARS: Record<UserGender, string> = {
  male: '/avatars/default-male.jpg',
  female: '/avatars/default-female.jpg',
};

export function isUserGender(value: unknown): value is UserGender {
  return value === 'male' || value === 'female';
}

export function resolveUserAvatarUrl(user?: {
  avatar_url?: string | null;
  gender?: UserGender | string | null;
} | null): string | undefined {
  if (!user) return undefined;
  if (user.avatar_url) return user.avatar_url;
  if (isUserGender(user.gender)) return DEFAULT_USER_AVATARS[user.gender];
  return undefined;
}
